import { combineReducers } from 'redux';
import commonReducer from './commonReducer';
import dashboardReducer from './dashboardReducer';
import myAppointmentReducer from './myAppointmentReducer';
import myProfileReducer from './myProfileReducer';
import myPurchasesReducer from './myPurchasesReducer';

const rootReducer = combineReducers({
    common: commonReducer,
    dashboard: dashboardReducer,
    myAppointment: myAppointmentReducer,
    myProfile: myProfileReducer,
    myPurchases: myPurchasesReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
